class ProductVideoList {
  constructor(container) {
    if (container.dataset.productVideoListInitialized === 'true') return;

    this.container = container;
    this.container.dataset.productVideoListInitialized = 'true';
    this.mediaItems = Array.from(container.querySelectorAll('.product-video-list__media'));
    this.modal = document.getElementById(container.dataset.modalId);
    this.activeIndex = 0;

    this.mediaItems.forEach((media) => {
      media.addEventListener('click', this.openModal.bind(this));
      media.addEventListener('keydown', this.onKeyDown.bind(this));
    });

    if (!this.modal) return;

    this.slides = Array.from(this.modal.querySelectorAll('[data-video-modal-slide]'));
    this.thumbnails = Array.from(this.modal.querySelectorAll('[data-video-modal-thumbnail]'));
    this.currentCounter = this.modal.querySelector('[data-video-modal-current]');
    this.previousButton = this.modal.querySelector('[data-video-modal-prev]');
    this.nextButton = this.modal.querySelector('[data-video-modal-next]');

    this.previousButton?.addEventListener('click', () => this.showVideo(this.activeIndex - 1, true));
    this.nextButton?.addEventListener('click', () => this.showVideo(this.activeIndex + 1, true));
    this.thumbnails.forEach((thumbnail) => {
      thumbnail.addEventListener('click', () => this.showVideo(Number(thumbnail.dataset.videoModalThumbnail), true));
    });
    this.modal.addEventListener('keydown', this.onModalKeyDown.bind(this));
    this.modal.addEventListener('transitionend', () => {
      if (!this.modal.hasAttribute('open')) this.pauseModalVideos();
    });
    document.body.addEventListener('modalClosed', () => this.pauseModalVideos());
  }

  onKeyDown(event) {
    if (event.key !== 'Enter' && event.key !== ' ') return;

    event.preventDefault();
    this.openModal(event);
  }

  openModal(event) {
    const media = event.currentTarget;
    if (!this.modal || typeof this.modal.show !== 'function') return;

    media.querySelector('video')?.pause();
    this.showVideo(Number(media.dataset.videoIndex));
    this.modal.show(media);
    this.playActiveVideo();
  }

  onModalKeyDown(event) {
    if (event.target.closest('video') || this.slides.length < 2) return;

    if (event.key === 'ArrowLeft') {
      event.preventDefault();
      this.showVideo(this.activeIndex - 1, true);
    }
    if (event.key === 'ArrowRight') {
      event.preventDefault();
      this.showVideo(this.activeIndex + 1, true);
    }
  }

  showVideo(index, playVideo = false) {
    if (!this.slides?.length) return;

    this.activeIndex = (index + this.slides.length) % this.slides.length;
    this.pauseModalVideos();

    this.slides.forEach((slide, slideIndex) => {
      const isActive = slideIndex === this.activeIndex;
      slide.hidden = !isActive;
      slide.classList.toggle('is-active', isActive);
    });

    this.thumbnails.forEach((thumbnail, thumbnailIndex) => {
      const isActive = thumbnailIndex === this.activeIndex;
      thumbnail.classList.toggle('is-active', isActive);
      thumbnail.setAttribute('aria-selected', String(isActive));
    });

    if (this.currentCounter) this.currentCounter.textContent = this.activeIndex + 1;
    this.thumbnails[this.activeIndex]?.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
    if (playVideo) this.playActiveVideo();
  }

  playActiveVideo() {
    const activeVideo = this.slides[this.activeIndex]?.querySelector('video');
    if (!activeVideo) return;

    const playPromise = activeVideo.play();
    if (!playPromise) return;

    playPromise.catch(() => {
      activeVideo.muted = true;
      activeVideo.play().catch(() => {});
    });
  }

  pauseModalVideos() {
    this.slides?.forEach((slide) => slide.querySelector('video')?.pause());
  }
}

const initProductVideoLists = (scope = document) => {
  scope.querySelectorAll('.product-video-list').forEach((container) => new ProductVideoList(container));
};

initProductVideoLists();

document.addEventListener('shopify:section:load', (event) => initProductVideoLists(event.target));
document.addEventListener('product-info:loaded', (event) => initProductVideoLists(event.target));
